import { render, staticRenderFns } from "./ClaimExcess.vue?vue&type=template&id=9af16c70&"
import script from "./ClaimExcess.vue?vue&type=script&lang=js&"
export * from "./ClaimExcess.vue?vue&type=script&lang=js&"
import style0 from "./ClaimExcess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports